import { FileTxt } from '@phosphor-icons/react';

export default FileTxt;